import React from "react";
import {BookingComProps} from "../../types/BookingComProps";

// https://brandfetch.com/booking.com

export const BookingCom: React.FC<BookingComProps> = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.size || props.width}
            height={props.height}
            className={props.className}
            onClick={props.onClick}
            viewBox="0 0 304.1 50.4"
            style={{fill: '#003B95'}}
        >
            <g transform="translate(-358.09311,-676.33649)">
                <g transform="matrix(1.25,0,0,-1.25,-378.53164,712.40679)">
                    <g>
                        <g>
                            <g>
                                <g>
                                    <g>
                                        <path d="M684.8,25.2c0,2.1,1.7,3.7,3.7,3.7s3.7-1.7,3.7-3.7s-1.7-3.7-3.7-3.7C686.4,21.5,684.8,23.2,684.8,25.2"/>
                                        <path d="M743.2,0.6c0,2.1,1.7,3.7,3.7,3.7s3.7-1.7,3.7-3.7s-1.7-3.7-3.7-3.7C744.8-3.1,743.2-1.5,743.2,0.6"/>
                                        <path d="M624.1,2.2c-3.2,0-5.4,2.5-5.4,6.1s2.2,6.1,5.4,6.1s5.4-2.5,5.4-6.1C629.5,4.6,627.3,2.2,624.1,2.2z M624.1,19.9c-6.7,0-11.6-4.9-11.6-11.5s4.9-11.5,11.6-11.5c6.8,0,11.7,4.9,11.7,11.5S630.8,19.9,624.1,19.9"/>
                                        <path d="M677.6,7.7c-0.3,0.5-0.6,0.9-0.9,1.2l-0.2,0.2l0.2,0.2c0.3,0.3,0.6,0.7,0.9,1.2l5.9,8.8h-7.2l-4.5-6.9c-0.3-0.4-0.8-0.6-1.5-0.6h-1v13.1c0,2.6-1.6,3-3.4,3h-3V-3h6.4v9.3h0.6c0.7,0,1.2-0.1,1.5-0.5l3.5-6.7c1-1.8,2-2.1,3.8-2.1h4.9l-3.7,6L677.6,7.7"/>
                                        <path d="M708.7,19.9c-3.3,0-5.3-1.4-6.5-2.7l-0.4-0.4l-0.1,0.5c-0.3,1.3-1.5,2-3.2,2h-2.9V-3h6.4V7.4c0,1,0.1,1.9,0.4,2.7c0.7,2.4,2.7,3.9,5.1,3.9c2,0,2.8-1,2.8-3.8V0.5c0-2.3,1.1-3.4,3.4-3.4h3v14.2C716.6,16.9,713.9,19.9,708.7,19.9"/>
                                        <path d="M688.6,19.4h-3V2.2l0,0v-5.1h3.2h0.1h1.5h1.5l0,0l0,0V16C691.9,18.3,690.8,19.4,688.6,19.4"/>
                                        <path d="M649,2.2c-3.2,0-5.4,2.5-5.4,6.1s2.2,6.1,5.4,6.1s5.4-2.5,5.4-6.1C654.5,4.6,652.3,2.2,649,2.2z M649,19.9c-6.7,0-11.6-4.9-11.6-11.5S642.3-3.2,649-3.2c6.8,0,11.7,4.9,11.7,11.5S655.8,19.9,649,19.9"/>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
                <g transform="matrix(1.25,0,0,-1.25,-378.53164,712.40679)">
                    <g>
                        <g>
                            <g>
                                <g>
                                    <g>
                                        <g>
                                            <g>
                                                <g>
                                                    <g>
                                                        <path d="M785.3,2.2c-3.2,0-5.4,2.5-5.4,6.1s2.2,6.1,5.4,6.1s5.4-2.5,5.4-6.1C790.7,4.6,788.5,2.2,785.3,2.2z M785.3,19.9c-6.7,0-11.6-4.9-11.6-11.5s4.9-11.5,11.6-11.5C792-3.2,797,1.6,797,8.3S792,19.9,785.3,19.9"/>
                                                        <path d="M730,3.1c-3.5,0-4.7,3-4.7,5.9c0,1.3,0.3,5.3,4.4,5.3c2,0,4.7-0.6,4.7-5.5C734.4,4.1,732,3.1,730,3.1z M737.7,19.5c-1.2,0-2.1-0.5-2.6-1.4l-0.2-0.3l-0.3,0.3c-1,0.9-2.9,1.9-5.9,1.9c-5.9,0-9.9-4.5-9.9-11.1s4.1-11.3,10.1-11.3c2,0,3.6,0.5,4.9,1.4l0.5,0.4v-0.6c0-3-1.9-4.6-5.4-4.6c-1.7,0-3.2,0.4-4.3,0.8c-1.3,0.4-2.1,0.1-2.7-1.3l-0.5-1.2l-0.7-1.8l0.4-0.2c2.2-1.2,5.1-1.9,7.8-1.9c5.4,0,11.7,2.8,11.7,10.6v20.5L737.7,19.5"/>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
                <g transform="matrix(1.25,0,0,-1.25,-378.53164,712.40679)">
                    <g>
                        <g>
                            <g>
                                <g>
                                    <g>
                                        <g>
                                            <path d="M600.4,2.4h-5.2v6.2c0,1.3,0.5,2,1.6,2.2h3.5c2.5,0,4.1-1.6,4.1-4.2C604.5,4,603,2.4,600.4,2.4L600.4,2.4z M595.2,19.1v1.6c0,1.4,0.6,2.1,1.9,2.2h2.6c2.3,0,3.6-1.4,3.6-3.6c0-1.7-0.9-3.8-3.5-3.8h-4.7L595.2,19.1L595.2,19.1z M607,12.9l-0.9,0.5l0.8,0.7c0.9,0.8,2.5,2.7,2.5,5.8c0,4.9-3.8,8-9.6,8h-6.6l0,0h-0.8c-1.7-0.1-3.1-1.5-3.1-3.2V-2.8h3.1l0,0h7.6c6.5,0,10.7,3.5,10.7,9C610.6,9.1,609.3,11.7,607,12.9"/>
                                            <path d="M825.3,19.8c-2.6,0-5.2-1.2-6.8-3.3l-0.5-0.6l-0.4,0.7c-1.2,2.1-3.2,3.2-6,3.2c-3,0-4.9-1.6-5.9-2.6l-0.6-0.7l-0.2,0.9c-0.3,1.2-1.4,1.9-3.1,1.9h-2.7V-2.9h6.1v9.8c0,0.9,0.1,1.7,0.3,2.6c0.6,2.4,2.2,4.9,4.8,4.7c1.7-0.2,2.5-1.4,2.5-3.9V-2.9h6.1v9.8c0,1.1,0.1,1.9,0.3,2.7c0.5,2.3,2.2,4.6,4.7,4.6c1.9,0,2.6-1.1,2.6-3.9V0.4c0-2.2,1-3.2,3.2-3.2h2.9v14.2C832.7,17,830.3,19.8,825.3,19.8"/>
                                            <path d="M770.1,4.8c0,0-2.6-2.8-6.1-2.8c-3.1,0-6.3,1.9-6.3,6.2c0,3.7,2.5,6.3,6,6.3c1.1,0,2.4-0.4,2.6-1.1v-0.1c0.5-1.6,1.9-1.6,2.2-1.6h3.3v2.9c0,3.8-4.9,5.2-8.2,5.2c-7,0-12.1-4.9-12.1-11.6s5-11.6,12-11.6c6,0,9.3,4,9.3,4l0.2,0.2l-2.6,4.4L770.1,4.8"/>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};
